import React, { useEffect, useState } from "react"
import GlobalInsights from "./GlobalInsights"
import InsightsView from "../InsightsView"

export const globalInsightsConstants = {
  rowHeight: 24,
  labelRankPadding: 5,
  labelRankWidth: 28,
  sidePadding: 32,
  labelWidthPercentage: 0.3,
  fullBarWidthPercentage: 0.7,
  barHeight: 24 * 0.8,
  minLabelWidth: 140,
}

export default function GlobalInsightsControls(props) {

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true)
    }, 200)
  }, [])

  if(!loaded) {
    return null
  }

  return (
    <InsightsView {...props}>
      <GlobalInsights />
    </InsightsView>
  )
}
